module.exports = "<button\n  [id]=\"id\"\n  [class.outline]=\"outline\"\n  [class.full]=\"full\"\n  [class.secondary]=\"variant === 'secondary'\"\n  [class.tertiary]=\"variant === 'tertiary'\"\n  [class.quaternary]=\"variant === 'quaternary'\"\n  [disabled]=\"disabled\"\n  [type]=\"type\">\n  <ng-content></ng-content>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-button/alg-button.component.html
// module id = ./src/app/components/atoms/alg-button/alg-button.component.html
// module chunks = main